import LayoutSdk from '@notes/sticky-notes-layout';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getDefaultAnchorMailboxCookie } from 'owa-service/lib/anchormailbox';
import { getUserConfiguration } from 'owa-session-store';

async function getTokenForNotes(): Promise<string> {
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(window.location.origin);
    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = await tokenPromise;
    }
    return token;
}

function authNotesSDK() {
    getTokenForNotes().then(token => {
        const defaultAnchorMailbox = getDefaultAnchorMailboxCookie();
        notesSdk.setAADAccessToken(token, defaultAnchorMailbox, 'OWA');
    });
}

var notesSdk = null;
export default function getNotesSDK(): LayoutSdk {
    if (notesSdk == null) {
        notesSdk = new LayoutSdk({
            appName: 'OWA',
            appVersion: '0.1',
            sync: true,
            storage: false,
            uniqueUserId: getDefaultAnchorMailboxCookie(),
            onUnauthorized: () => {
                authNotesSDK();
            },
            showAppHeader: true,
        });
        notesSdk.ready.then(() => {
            authNotesSDK();
            notesSdk.changeLanguage(getUserConfiguration().SessionSettings.UserCulture);
        });
    }
    return notesSdk;
}
